// Pepe skins — unlock gated by best score.
// Each skin changes base color and/or adds accessories drawn in canvas.

export const SKINS = [
  {
    id: "classic",
    name: "Classic Pepe",
    unlockBest: 0,
    body: "#39ff14",
    cheek: "#7cff5e",
    tag: "OG",
  },
  {
    id: "chad",
    name: "Chad Pepe",
    unlockBest: 5,
    body: "#39ff14",
    cheek: "#9fff80",
    tag: "GIGACHAD",
    accessories: ["shades", "chinbeard"],
  },
  {
    id: "astronaut",
    name: "Astronaut Pepe",
    unlockBest: 15,
    body: "#39ff14",
    cheek: "#7cff5e",
    tag: "ASTRO",
    accessories: ["helmet"],
  },
  {
    id: "rare",
    name: "Rare Pepe",
    unlockBest: 30,
    body: "#f6d365",
    cheek: "#fda085",
    tag: "RARE",
    accessories: ["rainbow", "crown"],
  },
];

const STORE_KEY = "flappy-pepe-skin";

export function getUnlockedSkins(best) {
  return SKINS.filter((s) => best >= s.unlockBest).map((s) => s.id);
}

export function getSkin(id) {
  return SKINS.find((s) => s.id === id) || SKINS[0];
}

export function loadSelectedSkin(best) {
  const stored = localStorage.getItem(STORE_KEY) || "classic";
  const unlocked = getUnlockedSkins(best);
  return unlocked.includes(stored) ? stored : "classic";
}

export function saveSelectedSkin(id) {
  localStorage.setItem(STORE_KEY, id);
}

// Returns ids newly crossed between oldBest and newBest.
export function detectNewlyUnlocked(oldBest, newBest) {
  if (newBest <= oldBest) return [];
  return SKINS.filter(
    (s) => s.unlockBest > oldBest && s.unlockBest <= newBest,
  ).map((s) => s.id);
}
